<template>
  <div>
      
       <div style="padding-left:10px;padding-right:10px;">        
            <div class="allNotasConteudo">
                <div :class="{allNotas:true, 'bloco':true,emitidas:emitidas}" @click="GetNotasEmitRe('primeira',$store.state.tipoNota == 'NFe'? 'DEST' : $store.state.tipoNota == 'NFCe' ? 2:'Tomador')">
                    <p>{{txtN1}}</p>
                </div>
                <div :class="{allNotas:true, 'bloco':true,recebidas:recebidas}" @click="GetNotasEmitRe('segunda',$store.state.tipoNota == 'NFe'? 'EMIT' : $store.state.tipoNota == 'NFCe' ? 1: 'Não Tomador')">
                    <p>{{txtN2}}</p>
                </div>
            </div>
            <div>
                <TableNotas  v-if="true" :notasq="notas" :emitidas="emitidas"> </TableNotas>
                <div v-if="!existeNota" style="margin-top: 50px;font-weight: 600;">
                    Não existe nota
                </div>
            </div>
        </div>
        <vue-topprogress ref="topProgress"></vue-topprogress>
  </div>
</template>

<script>
import TableNotas from './TableNotas'
import { vueTopprogress } from "vue-top-progress";
import config from '../services/config'
export default {
components: { TableNotas,vueTopprogress},
props:['existeNota','notas','objEnviaNotas'],
data(){
    return{
        emitidas: true,
        recebidas:false,
        txtN1:'Recebidas',
        txtN2:'Emitidas',       
    }
},
methods:{
    async GetNotasEmitRe(t,e){  
        if(t=='primeira'){
            this.emitidas = false
            this.recebidas = true
            if(this.$store.state.tipoNota == 'NFe'){   
                this.objEnviaNotas.obj.tag = 'DEST'     
                this.$store.state.opNota           = 'DEST' 
            }else if(this.$store.state.tipoNota == 'CTe'){                 
                this.objEnviaNotas.obj.tag = 'Tomador'    
                this.$store.state.opNota           = 'Tomador'            
            }
        }else{
            if(this.$store.state.tipoNota == 'NFe'){   
                this.objEnviaNotas.obj.tag = 'EMIT'     
                  this.$store.state.opNota           = 'EMIT'            
            }else if(this.$store.state.tipoNota == 'CTe'){                 
                this.objEnviaNotas.obj.tag = 'Não Tomador'   
                  this.$store.state.opNota           = 'Não Tomador'             
            }
            this.recebidas = false
            this.emitidas = true
        }
            this.$emit('pegarTag',e)            
            this.$refs.topProgress.start();              
            this.recebidas = !this.recebidas
            this.emitidas = !this.emitidas      
            this.objEnviaNotas.obj.numeroPagina = 1          
            let status = await config[this.objEnviaNotas.nome](this.objEnviaNotas.obj)          
            if(status.status >= 400){
                 this.$emit('existeNota',false) 
                 this.$emit('getNotas',[])                  
                   this.$emit('valorNota', 0)
            }else{   
                this.$emit('existeNota',true)               
                this.$emit('getNotas',status.data.lstNotas)
                this.$emit('quantTotal',status.data.quantidadeTotal)
                this.$emit('valorNota', status.data.valorTotal)  
            }
            this.$refs.topProgress.done();
        }
    },
    mounted(){    
        console.log('vindo')
    if(this.$store.state.opNota ==  'EMIT' || this.$store.state.opNota ==  'Não Tomador'){
        this.recebidas = true
        this.emitidas = false
       
    }else {
         this.recebidas = false
            this.emitidas = true
    }
        if(this.$store.state.tipoNota == 'NFe'){    
            this.txtN1 = 'Recebidas' 
            this.objEnviaNotas.obj.tag = 'DEST'
            this.txtN2 = 'Emitidas'
        }else if(this.$store.state.tipoNota == 'CTe'){   
            this.txtN1 = 'Tomador' 
            this.objEnviaNotas.obj.tag = 'Tomador'
            this.txtN2 = 'Não Tomador'   
        }else{        
            this.txtN1 = 'Recebidas' 
            this.objEnviaNotas.obj.tag = 2
            this.txtN2 = 'Emitidas'   
        }      
    }
}
</script>

<style>
.allNotasConteudo  .recebidas{
    background:  #009188 !important;
    font-weight: bold;    
    color:#fff !important;
}
.allNotasConteudo  .emitidas{  
    background:  #009188 !important;
    font-weight: bold;    
    color:#fff !important;
}
.allNotasConteudo  .bloco{
    background: #E5F4F3 ;
    color:#818181;
}
.allNotasConteudo{
    display: flex;
    justify-content: space-between;
    margin-top:65px;  
    cursor: pointer;
}
.allNotasConteudo .allNotas{
    width: 49.5%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    font-size: 18px;
}
.allNotasConteudo .allNotas p{
    margin:0px;
}
</style>